import CRUDService from './CRUDService';

export interface UploadDetails {
  maxFileSize: number;
  allowedFileTypes?: string[];
}

export default new CRUDService<UploadDetails>('/v1/upload-type');
